"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternetServiceCms = void 0;
var InternetServiceCms = /** @class */ (function () {
    function InternetServiceCms() {
        this.modelHeadingLabel = 'About your Internet service';
        this.modelDescriptionOneTxt = 'Looks like your home Internet service provider is not AT&T.';
        this.modelDescriptionTwoTxt = 'You\'ll need to contact your Internet provider to have your current '
            + 'service disconnected. You can do this after you submit your order. Just be sure it\'s '
            + 'before we install your new service.';
    }
    return InternetServiceCms;
}());
exports.InternetServiceCms = InternetServiceCms;
//# sourceMappingURL=internetservice.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/WorkServiceConflictCard/internetservice.cms.js
// module id = 1982
// module chunks = 8